import classNames from "classnames";
import { getBadgeTheme } from "./badgeTheme";
import styles from "./style.module.scss";

type StatusType = "inprogress" | "pending" | "completed" | "inactive" | string;

interface CustomBadgeProps {
  title: string | any;
  statusType?: StatusType | string;
  bg?: string | any;
  textColor?: string | any;
  borderColor?: string | any;
  containerStyle?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
  className?: string;
}

const formatStatusText = (status: string): string => {
  if (!status) return "";

  if (status.toLowerCase() === "co-collaborator") {
    return "Co-collaborator";
  }

  return status
    .replace(/_/g, " ")
    .split(/(\s|-)/)
    .map((part) => {
      if (part === "-" || /^\s+$/.test(part)) return part;
      if (part.length > 0) {
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      }
      return part;
    })
    .join("");
};

const CustomBadge = ({
  title,
  statusType,
  bg = "#ed1c240f",
  textColor = "#ED1C24",
  borderColor = "#ED1C24",
  containerStyle,
  titleStyle,
  className,
}: CustomBadgeProps) => {
  const theme = getBadgeTheme(statusType);

  const backgroundColor = theme ? theme.bg : bg;
  const color = theme ? theme.color : textColor;
  const border = theme ? theme.color : borderColor;

  const displayTitle =
    typeof title === "string" ? formatStatusText(title) : title;

  return (
    <div
      style={{
        backgroundColor,
        borderColor: border,
        ...containerStyle,
      }}
      className={classNames(styles.badge_container, className)}
    >
      <span
        style={{
          color,
          ...titleStyle,
        }}
        className={styles.badge_title}
      >
        {displayTitle}
      </span>
    </div>
  );
};

export default CustomBadge;
